import React from "react";
import { FolderKanban } from "lucide-react";

const ProjectList = React.lazy(() => import("./ProjectList"));
const ProjectShow = React.lazy(() => import("./ProjectShow"));
const ProjectCreate = React.lazy(() => import("./ProjectCreate"));
const ProjectEdit = React.lazy(() => import("./ProjectEdit"));

export default {
  list: ProjectList,
  show: ProjectShow,
  create: ProjectCreate,
  edit: ProjectEdit,
  icon: FolderKanban,
};
